import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

export const usePageTracking = () => {
    const location = useLocation();

    useEffect(() => {
        // Har route change par GTM ko page view bhejna
        if (window.dataLayer) {
            window.dataLayer.push({
                event: 'pageview',
                page: location.pathname + location.search,
                title: document.title || 'AapkaPG'
            });
            console.log('📊 Page View Tracked:', location.pathname);

            // 1. Check dataLayer
            console.log('📦 dataLayer:', window.dataLayer);

            // 2. Check GTM loaded
            console.log('🏷️ GTM Loaded:', typeof window.google_tag_manager !== 'undefined');

            // 3. Check container
            // console.log('📦 Container:', window.google_tag_manager['GTM-MXSN3HQ7']);
            console.log('📦 Container:', window.google_tag_manager);

            // 4. Check all events in dataLayer
            console.log('📊 Events:', window.dataLayer.map(item => item.event || 'no-event'));

        }
    }, [location]);
};